declare const THREE: any;

export class SizeDetector {

  private box;
  private size;

  constructor() {
    this.box = new THREE.Box3();
    this.size = new THREE.Vector3();
  }

  detect(model) {
    this.box.setFromObject(model);
    this.box.getSize(this.size);
    return this.size;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/SizeDetector.ts